export const medicationListExpression = '*.*.medicationlist';
export const planClaimHeaderExpression = '[*.*.planClaimHeader]';
export const allergyExpression = '*.*.allergy';
